import axios from 'axios';
import { getApplication } from 'config/configure';
import {
  CreateProfileRequest,
  CreateProfileResponse,
  SocialAuthRequest,
  SocialAuthResponse,
} from './types';
import { getUserEndpoint } from './utils';

export async function createUserProfile({
  spareminToken,
  userId,
  ...args
}: CreateProfileRequest): Promise<void> {
  const url = getUserEndpoint('createProfile', { userId });
  const { data } = await axios.post<CreateProfileResponse>(url, args, {
    headers: {
      Authorization: spareminToken,
    },
  });

  return data;
}

export async function socialAuth({
  identityProvider,
  ...opts
}: SocialAuthRequest): Promise<SocialAuthResponse> {
  const url = getUserEndpoint('socialAuth', { identityProvider });
  const { data, status } = await axios.post<SocialAuthResponse>(url, {
    ...opts,
    platform: 'desktopWeb',
    application: getApplication(),
  });

  const userCreated = status === 201;

  return {
    ...data,
    userCreated,
  };
}
